<template>
  <v-card class="mt-5">
    <AppVCardTitle label="Contrôles visuels divers - Hors trou d’homme"/>
    <AppCheckboxWithConformityForm v-model="value.tankConditions"
                                   label="Contrôle de l’état général de la cuve (défauts peinture, coulures, coups, rouille, usure) *"
                                   :required="true"/>
    <AppCheckboxWithButton v-model="value.regulatoryPlates.checked"
                           label="Vérification de la présence des plaques réglementaires *"
                           image_url="/img/implementedForms/62b97ed722d02/regulatoryPlates.png" :required="true"/>

    <AppRadioYesNo v-if="value.regulatoryPlates.checked === true" v-model="value.regulatoryPlates.fourdataQRCode"
                   label="QR Code Télémétrie Four Data"/>

    <v-card-text class="pt-0 pb-0">
      <v-textarea v-if="value.regulatoryPlates.checked && value.regulatoryPlates.fourdataQRCode === 'true'"
                  v-model="value.regulatoryPlates.commentFourdataQrCode" placeholder="Commentaire" filled auto-grow
                  rows="1"/>
    </v-card-text>

    <div class="mx-4">
      <v-text-field
          ref="qrCodeLinkInput"
          v-model.trim="qrCodeLink"
          label="Url du bon QR code ou scan du bon QR code..."
          :loading="checkingQrCode"
          @change="generatedQrcode"
          filled
      >
        <template v-slot:append>
          <v-icon color="primary" data-cy="show-scanner" @click="showScanner">mdi-qrcode-scan</v-icon>
        </template>
      </v-text-field>
      <div v-if="clientMatchStatus !== null" class="mt-n4 mb-3">
        <div class="d-flex align-center" style="gap: 6px">
          <v-icon :color="clientMatchStatus ? 'success' : 'error'">
            {{ clientMatchStatus ? 'mdi-check-circle' : 'mdi-close-circle' }}
          </v-icon>
          <span :class="clientMatchStatus ? 'success--text' : 'error--text'" class="body-2 font-weight-medium">
            {{ clientMatchStatus ? 'Client correspond au QR code' : 'Client ne correspond pas au QR code' }}
          </span>
        </div>
        <div v-if="clientMatchStatus === false" class="mt-1 ml-1">
          <a :href="installer_url" target="_blank" class="body-2">
            Associer le QR code
            <v-icon small>mdi-open-in-new</v-icon>
          </a>
        </div>
      </div>
    </div>

    <div v-if="isShowScanner" class="mt-4">
      <v-progress-linear v-if="isLoadingScanner" width="2" indeterminate/>
      <v-icon class="fixed top-7 left-4 z-[1005] text-skin-primary" @click="isShowScanner = false">
        mdi-arrow-left
      </v-icon>

      <qrcode-stream
          :camera="camera"
          :constraints="videoConstraints"
          @decode="onDecode"
          @init="onInit"
      ></qrcode-stream>
    </div>

    <div v-if="qrCodeLink" class="mt-4 mx-auto d-none">
      <qrcode-vue ref="qrCodeCanvas" size="300" :value="qrCodeLink"></qrcode-vue>
    </div>

    <v-card-text v-if="value.regulatoryPlates.checked && value.regulatoryPlates.fourdataQRCode === 'false'"
                 class="mt-n2 pt-0">
      <p class="font-16 font-weight-bold">Merci de coller un QR code sur l'affiche et de l'associer au capteur</p>
    </v-card-text>

    <v-card-text class="mt-n2 pt-0">
      <p class="mb-0 mr-4"> Prendre en photo la plaque d'identification Oleo 100 *
        <v-dialog width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="primary" v-bind="attrs" v-on="on">
              <v-icon>fa fa-circle-info</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-img :src="'/img/implementedForms/62b97ed722d02/nameplate.jpeg'"></v-img>
            />
          </v-card>
        </v-dialog>
      </p>

      <AppImageInput v-model="value.regulatoryPlates.nameplateImage"
                     placeholder="Photo de la plaque d'identification Oleo 100"
                     :rules="[v => !!v && v.length === 1]"/>
    </v-card-text>

    <AppCheckboxWithButton v-if="value.regulatoryPlates.checked === true" v-model="value.regulatoryPlates.pastPoster"
                           label="Collage de l'affiche sur la cuve ainsi que le QR code dans le bon emplacement quelles que soient les conditions météorologiques *"
                           image_url="/img/implementedForms/62b97ed722d02/pastPoster.png" :required="true"/>

    <AppCheckboxWithButton v-if="value.regulatoryPlates.checked" v-model="value.regulatoryPlates.pellingPoster"
                           label="Changer l'affiche si elle est partiellement décollée"
                           image_url="/img/implementedForms/62b97ed722d02/posterPartiallyPeeledOff.jpeg"/>

    <v-card-text class="mt-n2 pt-0">
      <p class="mb-0 mr-4"> Photo de l'affiche *
        <v-dialog width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="primary" v-bind="attrs" v-on="on">
              <v-icon>fa fa-circle-info</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-img :src="'/img/implementedForms/62b97ed722d02/poster.jpeg'"></v-img>
            />
          </v-card>
        </v-dialog>
      </p>

      <AppImageInput v-model="value.regulatoryPlates.posterImage"
                     placeholder="Prendre en photo l'affiche"
                     :rules="[v => !!v && v.length === 1]" />
    </v-card-text>

    <v-card-text v-if="value.regulatoryPlates.checked === true" class="mt-n2 pt-0">
      <p class="mb-0 mr-4"> Photo du QR code zoomé *

        <v-dialog width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="primary" v-bind="attrs" v-on="on">
              <v-icon>fa fa-circle-info</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-img :src="'/img/implementedForms/62b97ed722d02/exampleQrCode.png'"></v-img>
          </v-card>
        </v-dialog>
      </p>

      <AppImageInput v-model="value.regulatoryPlates.qrCodeImage"
                     placeholder="Prendre en photo le QR code"
                     :rules="[v => !!v && v.length === 1]"/>
    </v-card-text>

  </v-card>
</template>

<script>
import AppCheckboxWithConformityForm
  from "@/components/MaintenanceViewReport/ImplementedForms/Oleo100Preventive/App/CheckboxWithConformityForm";
import AppCheckboxWithButton
  from "@/components/MaintenanceViewReport/ImplementedForms/Oleo100Preventive/App/CheckboxWithButton";
import AppRadioYesNo from "@/components/MaintenanceViewReport/ImplementedForms/Oleo100Preventive/App/RadioYesNo";
import AppVCardTitle from "@/components/MaintenanceViewReport/ImplementedForms/Oleo100Preventive/App/VCardTitle";
import AppImageInput from "@/components/App/ImageInput.vue";
import {QrcodeStream} from "vue-qrcode-reader";
import QrcodeVue from "qrcode.vue";
import QrCodeRepository from "@/repositories/QrCodeRepository";

export default {
  name: "VariousVisualControls",
  components: {
    QrcodeStream,
    QrcodeVue,
    AppImageInput,
    AppVCardTitle,
    AppCheckboxWithConformityForm,
    AppCheckboxWithButton,
    AppRadioYesNo,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isShowScanner: false,
      isLoadingScanner: false,
      qrCodeLink: this.value.regulatoryPlates.qrCodeLink ?? '',
      checkingQrCode: false,
      clientMatchStatus: null,
      camera: 'auto',
      videoConstraints: {
        facingMode: { ideal: 'environment' },
        width: { min: 640, ideal: 1280, max: 1920 },
        height: { min: 480, ideal: 720, max: 1080 }
      }
    }
  },
  computed: {
    installer_url() {
      return process.env.VUE_APP_INSTALLER_APP_URL + 'qr_code';
    }
  },
  watch: {
    qrCodeLink(val) {
      this.value.regulatoryPlates.qrCodeLink = val;
    },
  },
  mounted() {
    if (this.qrCodeLink) {
      this.getQrcodeByUid();
    }
  },
  methods: {
    onDecode(result) {
      if (!result) {
        return;
      }
      this.qrCodeLink = result;
      this.clientMatchStatus = null;
      this.generatedQrcode();
      this.getQrcodeByUid();
      this.isShowScanner = false;
    },
    generatedQrcode() {
      this.$nextTick(() => {
        const qrRef = this.$refs.qrCodeCanvas;
        if (!qrRef) return;

        const canvas = qrRef.$el instanceof HTMLCanvasElement ? qrRef.$el : qrRef.$el.querySelector('canvas');

        if (!canvas) return;

        this.value.regulatoryPlates.regenerateQrCode = canvas.toDataURL('image/png');
      })
    },
    getQrcodeByUid() {
      this.checkingQrCode = true;
      this.clientMatchStatus = null;

      return QrCodeRepository
          .getQrCodeByUid(this.qrCodeLink.split('/').pop())
          .then((response) => {
            this.$store.dispatch("snackbar/show", {
              snackbar_text: "QR code est bien associé",
              snackbar_type: "success",
            });

            const qrIdClient = response.data.data?.id_client
            const maintenanceIdClient = this.$store.getters["maintenance/get"].client?.id_client

            if (qrIdClient !== undefined && maintenanceIdClient !== undefined) {
              this.clientMatchStatus = qrIdClient === maintenanceIdClient
            }

            this.$nextTick(() => {
              this.$refs.qrCodeLinkInput.focus();
            });
          })
          .catch(() => {
            this.$store.dispatch("snackbar/show", {
              snackbar_text: "QR code n'est pas associé",
              snackbar_type: "error",
            });
            this.clientMatchStatus = null;
          })
          .finally(() => {
            this.checkingQrCode = false;
          })
    },
    showScanner() {
      this.isShowScanner = true;
      this.isLoadingScanner = true;
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        let errorMessage = "Erreur caméra";
        if (error.name === 'NotAllowedError') {
          errorMessage = "Accès caméra refusé";
        } else if (error.name === 'NotFoundError') {
          errorMessage = "Aucune caméra détectée";
        }
        this.$store.dispatch("snackbar/show", {
          snackbar_text: errorMessage,
          snackbar_type: "error",
        });
        this.isShowScanner = false;
      } finally {
        this.isLoadingScanner = false;
      }
    },
  },
};
</script>
